import { render, staticRenderFns } from "./policy-detail.vue?vue&type=template&id=185579f6&"
import script from "./policy-detail.vue?vue&type=script&lang=js&"
export * from "./policy-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports